import { render, staticRenderFns } from "./G-1-1a-2__SupportEdit_B2B_Warranty Policy.vue?vue&type=template&id=00292b13&"
import script from "./G-1-1a-2__SupportEdit_B2B_Warranty Policy.vue?vue&type=script&lang=js&"
export * from "./G-1-1a-2__SupportEdit_B2B_Warranty Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
